import { isOpenPartnerCancelPaymentModal } from "@/atoms/order/is-open-partner-cancel-payment-modal";
import PartnerVCCancleModal from "./PartnerVCCancleModal";
import { orderDetailState } from "@/atoms/order/order-detail-state";
import { GLOBAL_ERROR } from "@/common/constant/global-error";
import { ButtonColor } from "@/common/enum/button-color";
import { OrderStatus } from "@/common/enum/order-status";
import { PaymentStatus } from "@/common/enum/payment-status";
import { PaymentType } from "@/common/enum/payment-type";
import { PartnerOrderDetailHeader } from "@/components/header/PartnerOrderDetailHeader";
import { OrderDetailPageModaPanel } from "@/components/panel/OrderDetailPageModaPanel";
import { AdminOrderDetailReceiverTable } from "@/components/table/admin-order-receiver-table/AdminOrderDetailReceiverTable";
import { PartnerOrderDetailHeaderTable } from "@/components/table/partner-order-detail-header-table/PartnerOrderDetailHeaderTable";
import { ItemTable } from "@/components/table/partner-order-detail-item-table/ItemTable";
import { PartnerOrderPaymentTable } from "@/components/table/partner-order-payment-table/PartnerOrderPaymentTable1";
import { H5 } from "@/components/typography/H5";
import { PageWrapper } from "@/components/wrapper/PageWrapper";
import { orderService } from "@/services/order-service2";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Button } from "flowbite-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { profileState } from "../../atoms/user/profile-state";
import { PartnerOrderDetailReceiverTable } from "@/components/table/partner-order-receiver-table/PartnerOrderDetailReceiverTable";

export const canCancel = (orderDetail: OrderDetailDto) => {
  switch (orderDetail.payment.paymentMethod) {
    case PaymentType.PAVC:
      return (
        (orderDetail.payment.status === PaymentStatus.PENDING &&
          orderDetail.status === OrderStatus.DRAFT) ||
        orderDetail.status === OrderStatus.RECEIVED
      );
    case PaymentType.PALT:
      return orderDetail.status === OrderStatus.RECEIVED;
    default:
      return orderDetail.status === OrderStatus.RECEIVED;
  }
};

export const shouldShowPAVCModal = (orderDetail: OrderDetailDto) => {
  return (
    orderDetail.payment.paymentMethod === PaymentType.PAVC &&
    orderDetail.status === OrderStatus.RECEIVED
  );
};

export default function PartnerOrderDetailPage() {
  const [profile, setProfile] = useRecoilState(profileState);
  const [orderDetail, setOrderDetail] = useRecoilState(orderDetailState);
  const [modal, setModal] = useRecoilState(isOpenPartnerCancelPaymentModal);
  const [isPAVCModalOpen, setIsPAVCModalOpen] = useState(false);
  const { id } = useParams();

  const getOrderDetail = async () => {
    if (!id) {
      return;
    }

    try {
      const response = await orderService.getById(Number(id));
      if (!response.ok) {
        return alert(GLOBAL_ERROR);
      }
      setOrderDetail(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOrderDetail();
  }, [id]);

  if (!orderDetail || !profile) {
    return null;
  }

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1392px] h-full items-between justify-start gap-[16px]">
        <PartnerOrderDetailHeader orderDetail={orderDetail} />
        <PartnerOrderDetailHeaderTable orderDetail={orderDetail} />
        <div>
          <div className="h-[40px] py-[8px] flex items-center gap-[12px]">
            <H5 className="text-semantic-text-heading">발주 목록</H5>
          </div>
          <ItemTable orderDetail={orderDetail} />
        </div>

        <div>
          <div className="h-[40px] py-[8px] flex items-center gap-[12px]">
            <H5 className="text-semantic-text-heading">결제 정보</H5>
          </div>
          <PartnerOrderPaymentTable orderDetail={orderDetail} />
        </div>

        <div>
          <div className="h-[40px] py-[8px] flex items-center gap-[12px]">
            <H5 className="text-semantic-text-heading">배송 정보</H5>
          </div>
          <PartnerOrderDetailReceiverTable orderDetail={orderDetail} />
        </div>
        <div>
          {canCancel(orderDetail) && (
            <Button
              color={ButtonColor.RED}
              onClick={() => {
                if (shouldShowPAVCModal(orderDetail)) {
                  setIsPAVCModalOpen(true);
                } else {
                  setModal(true);
                }
              }}
            >
              발주 취소하기
            </Button>
          )}
        </div>
      </div>
      <OrderDetailPageModaPanel />
      <PartnerVCCancleModal
        show={isPAVCModalOpen}
        onClose={() => setIsPAVCModalOpen(false)}
      />
    </PageWrapper>
  );
}
